import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";

// Tarjeta KPI superior: título, descripción, valor y variación vs mes anterior
const KpiCard = ({
  title,
  subtitle,
  value,
  variation,
  showVariation,
  borderColor,
  darkMode,
  loading,
}) => {
  const isPositive = variation >= 0;
  const variationColor = isPositive ? "#3DB76E" : "#B81A1A";

  return (
    <Box
      sx={{
        flex: "1 0 0",
        minWidth: 0,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        overflow: "hidden",
        padding: "16px 10px",
        borderRadius: "12px",
        backgroundColor: darkMode ? "#000000DE" : "#FFFFFF",
        border: borderColor ? `2px solid ${borderColor}` : "none",
        boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "4px",
          width: "100%",
          wordBreak: "break-word",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Ubuntu !important",
            fontWeight: 700,
            fontSize: "14px",
            lineHeight: "normal",
            color: darkMode ? "#FFFFFF" : "#6B7280",
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontFamily: "Ubuntu !important",
            fontWeight: 500,
            fontSize: "12px",
            lineHeight: "normal",
            color: darkMode ? "rgba(255, 255, 255, 0.70)" : "#9CA3AF",
          }}
        >
          {subtitle}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          width: "100%",
        }}
      >
        {loading ? (
          <Skeleton variant="text" width="80%" height={32} />
        ) : (
          <Typography
            sx={{
              fontFamily: "Ubuntu !important",
              fontWeight: 700,
              fontSize: "24px",
              lineHeight: "normal",
              wordBreak: "break-word",
              color: darkMode ? "#FFFFFF" : "#111827",
            }}
          >
            {value}
          </Typography>
        )}
        {showVariation && !loading && (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {isPositive ? (
              <ArrowDropUp
                sx={{
                  fontSize: "14px",
                  marginRight: "-2px",
                  color: variationColor,
                }}
              />
            ) : (
              <ArrowDropDown
                sx={{
                  fontSize: "14px",
                  marginRight: "-2px",
                  color: variationColor,
                }}
              />
            )}
            <Typography
              sx={{
                fontFamily: "Ubuntu !important",
                fontWeight: 500,
                fontSize: "12px",
                lineHeight: "10px",
                letterSpacing: "0.15px",
                textAlign: "center",
                whiteSpace: "nowrap",
                color: variationColor,
              }}
            >
              {`${isPositive ? "" : "-"}${Math.abs(variation).toFixed(1)}%`}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

KpiCard.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  variation: PropTypes.number,
  showVariation: PropTypes.bool,
  borderColor: PropTypes.string,
  darkMode: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
};

KpiCard.defaultProps = {
  variation: 0,
  showVariation: false,
  borderColor: null,
};

export default KpiCard;
